import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { SnpApi } from "@jti/rest-api";
import { dispatchTrackingEvent, TrackingEvents } from "@jti/tracker";
import { Loading, Notification } from "@jti/ui";
const UnsubscribeBlock = ({ successMessage, errorMessage }) => {
    const [pending, setPending] = useState(true);
    const [success, setSuccess] = useState(false);
    useEffect(() => {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const topics = urlSearchParams.get("topics")?.split(",") || ["marketing"];
        const consentsIds = urlSearchParams.getAll("consent_id[]");
        SnpApi.init()
            .unsubscribe(urlSearchParams.get("subscriberUUID") || "", topics, consentsIds.length ? consentsIds : undefined)
            .then(() => {
            setSuccess(true);
            dispatchTrackingEvent(TrackingEvents.TrackingUnsubscribe);
        })
            .catch(() => {
            setSuccess(false);
        })
            .finally(() => {
            setPending(false);
        });
    }, []);
    if (pending) {
        return _jsx(Loading, { dataTestId: "usubscribeLoader" });
    }
    return (_jsx("div", { children: _jsx(Notification, { variant: success ? "checkmark" : "error", children: _jsx("div", { "data-testid": "unsubscribe-message", children: success ? successMessage : errorMessage }) }) }));
};
export default UnsubscribeBlock;
//# sourceMappingURL=UnsubscribeBlock.js.map